'use client';

import { FootballMatchModel } from '@nf/types/odds';
import { ScoreboardColumn } from './scoreboard-column';
import { TicketRunningIcon } from '@/components/icons/svg-icons';
import { scoreboardService } from '@/services/scoreboard.service';
import { FootballLiveScore } from '@nf/types/scoreboard';
import { ScoreboardFooter } from './scoreboard-footer';
import { TotalBoard } from './scoreboard-totalboard';
import { ScoreboardData, TotalScoreBoardProps } from '@/types/scoreboard-settings';
import { useTranslations } from 'next-intl';
import { Styles } from './scoreboard.style';
import { cx } from 'styled-system/css';

//美式足球
export const ScoreboardSp3 = ({ footballMatchModel }: { footballMatchModel: FootballMatchModel }) => {
	const t = useTranslations('General');
	const ls = footballMatchModel.ls;
	const footballScoreboardData: ScoreboardData[] = [];
	const footballScoreboardInfo = scoreboardService.getScoreboardSetting(footballMatchModel.GameID).info;
	const footballScoreboardOption = scoreboardService.getScoreboardSetting(footballMatchModel.GameID).options;
	const footballScoreboardSetting = scoreboardService.getScoreboardSetting(footballMatchModel.GameID).boardColumn;
	const totalScoreBoard: TotalScoreBoardProps = {
		TotalPoints: { homeTotalPoints: 0, awayTotalPoints: 0 }
	}
	const trn = ls[footballScoreboardOption.trn as keyof FootballLiveScore];

	const getTitle = (type: string, round?: number, keyValue?: string) => {
		let resourceKey = '';
		if (type === 'right') {
			switch (keyValue) {
				case 'dwn':
					resourceKey = t('livescoreHeader_Down');
					break;
				case '2go':
					resourceKey = t('livescoreHeader_ToGo');
					break;
			}
		} else {
			switch (round) {
				case 1:
					resourceKey = t('livescoreHeader_1Q');
					break;
				case 2:
					resourceKey = t('livescoreHeader_2Q');
					break;
				case 3:
					resourceKey = t('livescoreHeader_3Q');
					break;
				case 4:
					resourceKey = t('livescoreHeader_4Q');
					break;
				case 5:
					resourceKey = t('lbl_OT');
					break;
				default:
					resourceKey = t('livescoreHeader_TG');
					break
			}
		}
		return resourceKey;
	};

	footballScoreboardSetting.forEach((setting) => {
		switch (setting.type) {
			case 'set':
				let homeScore = ls[setting.keyValue?.[0] as keyof FootballLiveScore];
				let awayScore = ls[setting.keyValue?.[1] as keyof FootballLiveScore];
				if (parseInt(ls.llp, 10) >= (setting.round ?? 0)) {
					totalScoreBoard.TotalPoints.homeTotalPoints += parseInt(homeScore, 10);
					totalScoreBoard.TotalPoints.awayTotalPoints += parseInt(awayScore, 10);
				} else {
					homeScore = '-';
					awayScore = '-';
				}
				footballScoreboardData.push({
					heading: getTitle(setting.type, setting.round ?? 0),
					cells: [{ text: homeScore }, { text: awayScore }]
				});
				break;
			case 'total':
				footballScoreboardData.push({
					heading: 'total',
					cells: [
						{ text: setting.needCount ? totalScoreBoard.TotalPoints.homeTotalPoints : '-' },
						{ text: setting.needCount ? totalScoreBoard.TotalPoints.awayTotalPoints : '-' }
					]
				});
				break;
		}
	});

	return (
		<>
			<div className={cx('scoreboard scoreboard--sport3', Styles.scoreboard)}>
				<div className="scoreboard__col-event">
					<div className="scoreboard__cell-heading"></div>
					<div className="scoreboard__cell" data-current={trn === '1'} >
						<TicketRunningIcon />
						<span className="scoreboard__text">{t('lbl_ShortH')}</span>
					</div>
					<div className="scoreboard__cell" data-current={trn === '2'}>
						<TicketRunningIcon />
						<span className="scoreboard__text">{t('lbl_ShortA')}</span>
					</div>
				</div>
				{
					footballScoreboardData.map((column, index) => {
						if (column.heading === 'total') {
							return;
						}

						return (
							<div key={`${column.cells}${index}`} className="scoreboard__col">
								<ScoreboardColumn
									key={`${index}${footballMatchModel.MatchId}Column`}
									heading={column.heading}
									cells={column.cells}
								/>
							</div>
						);
					})
				}
				<div className="scoreboard__col-total">
					<div className="scoreboard__cell-heading">
						<span className="scoreboard__text">{getTitle('total')}</span>
					</div>
					{
						footballScoreboardData.find(x => x.heading === 'total')?.cells?.map((cell, index) => (
							<TotalBoard
								key={`${index}${footballMatchModel.MatchId}TotalScore`}
								totalScore={cell.text}
							/>
						))
					}
				</div>

				<div className="scoreboard__col-info">
					{
						footballScoreboardInfo?.map((x, index) => {
							let value = ls[x.keyValue as keyof FootballLiveScore];
							if (x.keyValue === '2go') {
								value = `${value}Y`;
							}
							return (
								<ScoreboardFooter type={x.type} title={getTitle(x.type, 0, x.keyValue)} value={value} key={index} />
							);
						})
					}
				</div>
			</div>
		</>
	);
};
